import App from '@elevio/kb-kit/lib/App';
import config from './config';
import './css/main.css';
const resolveDefaultExport = (moduleValue) => 'default' in moduleValue ? moduleValue.default : moduleValue;
const target = document.getElementById('kb-target');
if (!target)
    throw new Error('Cant find target div');
const renderApp = async () => {
    const reactModule = await import('react');
    const reactDomModule = await import('react-dom');
    const React = resolveDefaultExport(reactModule);
    const ReactDOM = resolveDefaultExport(reactDomModule);
    if (process.env.NODE_ENV !== 'production') {
        const axe = (await import('@axe-core/react')).default;
        axe(React, ReactDOM, 1000);
    }
    ReactDOM.render(React.createElement(App, { config }), target);
};
void renderApp();
